<ng-template #portalContent>
  <div
    class="toolbar footer"
    data-cy="batch-operation-toolbar-footer-portal"
  >
    <div class="toolbar-toggle-all">
      <mat-checkbox
        (change)="toggleSelection($event)"
        #toggleAll
        [matTooltip]="toggleAllTooltip"
        matTooltipPosition="above"
        data-cy="toolbar-toggle-page-items"
      ></mat-checkbox>
    </div>
    <div
      class="toolbar-counter"
      [matTooltip]="selectedCandidatesTooltip"
      [matTooltipDisabled]="true"
      matTooltipPosition="above"
      data-cy="toolbar-items-count-label"
    >{{ selectedAmount$ | async }} selected</div>
    <ng-content></ng-content>
    <div
      class="toolbar-close"
      (click)="close()"
    >
      <button
        mat-icon-button
        color="primary"
        [matTooltip]="closeAggregationTooltip"
        [matTooltipDisabled]="true"
        matTooltipPosition="above"
      >
        <mat-icon data-cy="toolbar-close-button">close</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
